export class VideoCard {
	readonly $container: HTMLElement;
	private $video: HTMLVideoElement;

	private readonly classActive: string = 'video-card--active';

	constructor(selector: HTMLElement) {
		this.$container = selector;
		if (!this.$container) return;

		this.init();
	}

	/**
	 * @desc Инициализировать компонент
	 */
	public init(): void {
		this.$video = this.$container.querySelector('video');

		if (!this.$video) return;

		this.$container.addEventListener('mouseenter', this.play);
		this.$container.addEventListener('mouseleave', this.pause);
	}

	/**
	 * @desc Удалить обработчики событий
	 */
	public destroy(): void {
		this.$container.removeEventListener('mouseenter', this.play);
		this.$container.removeEventListener('mouseleave', this.pause);
	}

	public play = (): void => {
		this.$container.classList.add(this.classActive);
		this.$video?.play();
	};

	public pause = (): void => {
		this.$container.classList.remove(this.classActive);
		this.$video?.pause();
	};
}
